import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DictionaryFuelFeeService } from 'src/app/shared';
import {
  CustomButtonDefinition,
  DataTableDataDefinition,
} from 'src/app/shared/fca-data-table';
import { DictionaryFuelFeeRecord } from 'src/app/shared/types/dictionary-fuelfee-record';
import { DictionaryType } from 'src/components/shared/dictionaries-layout';
import { DictionariesFuelFeesAddNewDialogComponent } from './dictionaries-fuelfees-add-new-dialog/dictionaries-fuelfees-add-new-dialog.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationDialogComponent } from 'src/components/shared/confirmation-dialog/confirmation-dialog.component';

@Component({
  standalone: false,
  selector: 'ddictionaries-fuelfees-tab',
  templateUrl: './dictionaries-fuelfees-tab.html',
  styleUrls: ['./dictionaries-fuelfees-tab.scss'],
})
export class DictionariesFuelFeesTab implements OnInit {
  title = 'Dictionary';
  dictionaryType = DictionaryType.FuelFees;

  pageSize = 10;
  data: DictionaryFuelFeeRecord[] | null = null;
  dataDefinition: DataTableDataDefinition<DictionaryFuelFeeRecord> = [
    {
      name: '',
      columns: [
        {
          fieldName: 'name',
          caption: 'Fuel Fee',
          valueType: 'text',
        },
        {
          fieldName: 'sapName',
          caption: 'SAP Name',
          valueType: 'text'
        },
      ],
    },
  ];

  customButtons: CustomButtonDefinition<DictionaryFuelFeeRecord>[] = [
    {
      icon: 'delete_outline',
      hint: 'Delete row',
      onClick: this.onDelete.bind(this) as (x: any) => {},
    },
  ];

  constructor(
    private fuelFeeService: DictionaryFuelFeeService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.fuelFeeService.getAll().subscribe((fuelFees) => {
      this.data = fuelFees;
    });
  }

  addFuelFee() {
    let data: {
      name: string;
    } = {
      name: '',
    };

    const dialogRef = this.dialog.open(
      DictionariesFuelFeesAddNewDialogComponent,
      {
        width: '350px',
        panelClass: 'custom-dialog-container',
        scrollStrategy: new NoopScrollStrategy(),
        data: data,
        disableClose: true,
      }
    );

    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result !== true) {
          this.snackBar.open('Fuel fee added.', undefined, {
            duration: 2000,
          });
          this.loadData();
        }
      },
    });
  }

  onDelete(record: DictionaryFuelFeeRecord) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        title: 'Confirmation',
        message: 'Are you sure you want to remove this item?',
        buttons: {
          cancel: 'No',
          confirm: 'Yes',
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Yes') {
        this.fuelFeeService.delete(record.id).subscribe({
          next: () => {
            this.loadData();
          },
          error: (error) => {
            if (error?.error?.ErrorCode === 'ERROR_DELETE_FUEL_FEE') {
              const lines: string[] = error.error.Message.split('\n');
              const records = lines.slice(1).filter((line) => line.trim() !== '');
              const recordsList = records.join('\n');
              const formattedMessage =
                `This Fuel Fee is currently used in Airport Contract List module for following records:\n\n${recordsList}`;

              this.dialog.open(ConfirmationDialogComponent, {
                width: '350px',
                scrollStrategy: new NoopScrollStrategy(),
                panelClass: 'preformatted-dialog',
                data: {
                  title: 'Attention',
                  message: formattedMessage,
                  buttons: {
                    confirm: 'OK',
                  },
                },
              });
            } else {
              this.snackBar.open('An error occurred while deleting the record.', 'Close', { duration: 5000 });
            }
          },
        });
      }
    });
  }
}
